import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-generic-confirmation-popup',
  templateUrl: './generic-confirmation-popup.component.html',
  styleUrls: ['./generic-confirmation-popup.component.scss']
})
export class GenericConfirmationPopupComponent implements OnInit {
  title: string;
  message: string;
  eventTypeId: any;
  tripStatusId: any;
  tripStatus: any;
  showTripDetails: boolean;


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GenericConfirmationPopupComponent>) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.title = this.data.title;
    this.message = this.data.message;
    this.eventTypeId = this.data.eventTypeId;
    this.tripStatusId = this.data.tripStatusId;
    this.tripStatus = this.data.tripStatus;
    this.showTripDetails = this.data.showTripDetails;

  }


  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
  getEventTypeLabel(eventTypeId: number): string {
    switch (eventTypeId) {
      case 11:
        return 'Unassigned';
      case 12:
        return 'Status Change';
      case 13:
        return 'Details Updated';
      default:
        return eventTypeId.toString() || '';
    }
  }


}
